import { useEffect, useState } from "react";
import { apiClient } from "@/App";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BellOff, BellRing } from "lucide-react";
import { currentSubscription, disablePush, enablePush, pushSupported } from "@/lib/push";

export const PushToggle = ({ variant = "light" }) => {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    currentSubscription().then((s) => setOn(!!s)).catch(() => setOn(false));
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (on) {
        await disablePush();
        setOn(false);
        toast.success("Push notifications turned off on this device");
      } else {
        await enablePush();
        setOn(true);
        await apiClient.post("/push/test");
        toast.success("Push notifications enabled — a test notification was sent");
      }
    } catch (e) {
      toast.error(e.message || "Could not change push settings");
    } finally {
      setBusy(false);
    }
  };

  const dark = variant === "dark";
  if (!pushSupported()) {
    return <p className={`text-xs ${dark ? "text-slate-400" : "text-slate-500"}`} data-testid="push-unsupported">Push not supported here (iPhone: add to Home Screen first)</p>;
  }
  return (
    <Button size="sm" variant="outline" onClick={toggle} disabled={busy}
      className={dark ? "border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800" : ""} data-testid="push-toggle-btn">
      {on ? <BellOff className="w-4 h-4 mr-2" /> : <BellRing className="w-4 h-4 mr-2" />}
      {on ? "Disable push" : "Enable push alerts"}
    </Button>
  );
};

export default PushToggle;
